/// <amd-module name="VSSUI/Spinner" />
export { Spinner } from "./Components/Spinner/Spinner";
export { ISpinnerProps, SpinnerOrientation, SpinnerSize } from "./Components/Spinner/Spinner.Props";
